var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWalletGray = function SvgWalletGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.589,
    height: 16.333
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108599",
    d: "M11.307 9.423a1.89 1.89 0 0 0 1.885 1.885h4.4v-3.77h-4.4a1.89 1.89 0 0 0-1.885 1.885Zm2.513 0a.628.628 0 1 1-.628-.628.63.63 0 0 1 .628.628Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108600",
    d: "M10.051 9.423a3.142 3.142 0 0 1 3.141-3.141h4.4V3.141a.63.63 0 0 0-.628-.628H.628A.63.63 0 0 0 0 3.141v12.564a.63.63 0 0 0 .628.628h16.333a.63.63 0 0 0 .628-.628v-3.141h-4.4a3.142 3.142 0 0 1-3.138-3.141Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108601",
    d: "M16.961.628v.628H.628a1.651 1.651 0 0 0-.308.025A2.512 2.512 0 0 1 2.512-.001h13.82a.63.63 0 0 1 .628.628Z"
  })));
};
export default SvgWalletGray;